import Loadable from './Loadable';

const PATH_PREFIX = '/code/:companyID';

export default [
  {
    name: 'code.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
    exact: true,
    component: Loadable(import('../ui/apps/code/dashboard')),
  },
  {
    name: 'code.list',
    path: `${PATH_PREFIX}/list`,
    exact: true,
    component: Loadable(import('../ui/apps/code/list')),
  },
  {
    name: 'code.detail',
    path: `${PATH_PREFIX}/:docID/detail`,
    exact: true,
    component: Loadable(import('../ui/apps/code/detail')),
  },
];
